import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import { AuthWrapper } from '@/components/AuthWrapper'
import { GlobalNotificationManager } from '@/components/GlobalNotificationManager'
import { MainLayout } from '@/components/MainLayout'
import { ThemeProvider } from '@/components/ThemeProvider'
import { Toaster } from '@/components/ui/sonner'

import { FEATURE_MATRIX } from '@/config/features'
import CockpitPage from '@/screens/clarity/CockpitPage'
import DashboardPage from '@/screens/clarity/DashboardPage'
import LensPages from '@/screens/clarityLens'
import SalesLensPage from '@/screens/clarityLens/salesLens'
import SpendLensPage from '@/screens/clarityLens/spendLens'
import {
  NotAllowedClarityPage,
  NotAuthorizedPage,
  NotFoundPage,
} from '@/screens/error'
import LoginPage from '@/screens/login'
import { ScalrBasePage } from '@/screens/scalrBase'
import SettingsPage from '@/screens/settings'
import TargetsPage from '@/screens/targets'
import { selectTenant, useAppSelector } from '@/store'

const getBaseName = () => {
  const basePath = import.meta.env.VITE_APP_BASE_PATH || '/'
  return basePath === '/' ? '' : basePath.replace(/\/$/, '')
}

function App() {
  const tenant = useAppSelector(selectTenant)
  const features = FEATURE_MATRIX[tenant]

  const useFilteredRoutes = () => {
    const routes = [
      ...(features.dashboard
        ? [
            {
              path: '/dashboard',
              element: <DashboardPage />,
            },
          ]
        : [
            {
              path: '/dashboard',
              element: <NotAllowedClarityPage pageTitle="Dashboard" />,
            },
          ]),
    ]

    return routes
  }

  const router = createBrowserRouter(
    [
      {
        path: '/',
        element: <AuthWrapper />,
        children: [
          {
            path: '/login',
            element: <LoginPage />,
          },
          {
            path: '/unauthorized',
            element: <NotAuthorizedPage />,
          },
          {
            path: '/',
            element: <MainLayout />,
            children: [
              ...useFilteredRoutes(),
              {
                path: '/clarity/:id',
                element: <CockpitPage />,
              },
              {
                path: '/clarity-lens/:id',
                element: <LensPages />,
              },
              {
                path: '/clarity-lens/sales-lens/:id',
                element: <SalesLensPage />,
              },
              {
                path: '/clarity-lens/spend-lens/:id',
                element: <SpendLensPage />,
              },
              {
                path: '/targets/:id',
                element: <TargetsPage />,
              },
              {
                path: '/scalr-base/:id',
                element: <ScalrBasePage />,
              },
              {
                path: '/core-suite/:id',
                element: <NotAllowedClarityPage pageTitle="Core Suite" />,
              },
              {
                path: '/settings',
                element: <SettingsPage />,
              },
              // 404
              {
                path: '*',
                element: <NotFoundPage />,
              },
            ],
          },
        ],
      },
    ],
    {
      basename: getBaseName(),
    }
  )
  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <RouterProvider router={router} />
      <Toaster />
      <GlobalNotificationManager />
    </ThemeProvider>
  )
}

export default App
